import { render, staticRenderFns } from "./SkinSetIconUrlDialog.vue?vue&type=template&id=2fedc94f&scoped=true&"
import script from "./SkinSetIconUrlDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinSetIconUrlDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedc94f",
  null
  
)

export default component.exports